/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ─── Mega-menu UX fix ──────────────────────────────────────────────────────
 * 1. ESC key closes open mega menus
 * 2. Clicking the dark backdrop area (outside nav__sub-wrap) closes the menu
 * 3. Moving mouse below the dropdown area closes it faster
 * ────────────────────────────────────────────────────────────────────────── */
(function() {
  // ESC key closes any open mega menu
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('header-details-disclosure.mega').forEach(function(el) {
        if (el.mainDetailsToggle && el.mainDetailsToggle.hasAttribute('open')) {
          el.close();
        }
      });
    }
  });

  // Click on the .nav__sub backdrop (the full-width dark overlay area outside the content)
  // This area has pointer-events:none by default, so we give it pointer-events:auto
  // and close the menu when clicking it (but not when clicking .nav__sub-wrap inside it)
  var style = document.createElement('style');
  style.textContent = 'header-details-disclosure.mega details[open] > .nav__sub { pointer-events: auto; cursor: pointer; }';
  document.head.appendChild(style);

  document.addEventListener('click', function(e) {
    var navSub = e.target.closest('.nav__sub');
    if (!navSub) return;
    var navSubWrap = navSub.querySelector('.nav__sub-wrap');
    // Only close if click was on the backdrop, not on the content
    if (navSubWrap && navSubWrap.contains(e.target)) return;
    var disclosure = e.target.closest('header-details-disclosure.mega');
    if (disclosure && disclosure.mainDetailsToggle && disclosure.mainDetailsToggle.hasAttribute('open')) {
      disclosure.close();
    }
  });
})();
